import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import AppStoreLightLargeSVG from '../icons/appStoreLightLargeSVG'

const Cta = ({ appStoreLink }) => {
  return (
    <section id="cta">
      <div className="flex flex-col items-center layout-space md:flex-row-reverse">
        <div className="w-full mb-6 md:w-3/5 md:mb-0 md:py-8">
          <div className="max-w-2xl pt-12 text-center md:pt-0 md:pl-8">
            <h2 className="mb-4 text-white heading">
              음성 텍스트 변환어플을 다운로드하시고, 30분 무료로 사용해 보세요!
            </h2>
            <p className="mb-8 text-white sub-heading">
              등록하시면 30분 음성 텍스트 변환서비스를 무료로 사용하실 수 있습니다.
            </p>
            <a href={appStoreLink} target="_blank" rel="noreferrer">
              <AppStoreLightLargeSVG className="mx-auto app-store-link" />
            </a>
          </div>
        </div>
        <div
          // className="relative flex-shrink-0"
          // style={{ width: '320px', height: '400px' }}
          className="w-full mr-8 md:w-2/5 md:pt-8 "
        >
          <StaticImage
            src="../images/devices-group.png"
            className="w-full"
            alt="VoxRec on IOS"
          />
        </div>
      </div>
    </section>
  )
}

export default Cta
